module.exports = __webpack_public_path__ + "static/media/award5.6c28ab91.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_139/images/award5.png
// module id = 1349
// module chunks = 0